import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { PopupNames } from 'contexts/PopupContext';
import { MirrorService } from 'services/MirrorService';

import { usePopup } from 'hooks/usePopup';
import { isNeedAgeVerificationEnabledSelector } from 'store/common/selectors';

export const useAgeVerificationPopup = () => {
  const isNeedAgeVerificationEnabled = useSelector(
    isNeedAgeVerificationEnabledSelector
  );

  const { handleOpenForce, handleClose, handleAction, checkIsOpen } = usePopup(
    PopupNames.AgeVerification
  );

  useEffect(() => {
    if (!isNeedAgeVerificationEnabled || !MirrorService.sumsubToken) return;

    if (!checkIsOpen()) {
      handleAction.current = (action: { type: string }) => {
        if (action.type === 'close') {
          handleClose();
        }
      };
      handleOpenForce(null);
    }
  }, [
    checkIsOpen,
    handleAction,
    handleClose,
    handleOpenForce,
    isNeedAgeVerificationEnabled,
  ]);
};
